import BreadcrumbDates from "components/core/blocks/BreadcrumbDates";
import { DASHBOARD_LINKS } from "utils/dashboardLinks";
import { useModuleEnabled } from "redux/selectors/modules";
import { Redirect } from "react-router-dom";
import AudiencesSection from "./AudiencesSection";
import { AMC_QUERY_EXPLORER_BREADCRUMB_SPEC } from "../utils";
import AMCAudienceDetails from "./AMCAudienceDetails";
import Tabs from "components/core/basic/Tabs";
import useQueryParams from "hooks/useQueryParams";
import { PageContainer } from "components/core/basic/PageContainer";
import { Container } from "react-bootstrap";

const AudienceDashboard = () => {
  const hasAMCModule = useModuleEnabled("AMC");
  const [tab, setTab] = useQueryParams("tab", "create");

  const breadCrumbItems = [
    {
      name: "AMC Dashboard",
      href: "/user/amc/dashboard",
      unsorted: true,
      dropdownLinkOptions: DASHBOARD_LINKS,
      dropdownSubtitle: "Reports",
    },
  ];

  if (!breadCrumbItems[0].dropdownLinkOptions?.find((o) => o.name === AMC_QUERY_EXPLORER_BREADCRUMB_SPEC.name)) {
    breadCrumbItems[0].dropdownLinkOptions.push(AMC_QUERY_EXPLORER_BREADCRUMB_SPEC);
  }

  if (!hasAMCModule) {
    return <Redirect to="/user/dashboard" />;
  }

  return (
    <>
      <BreadcrumbDates items={breadCrumbItems} hideDateSelector={true} />
      <PageContainer>
        <Container>
          <h1 className="text-center pt-4" style={{ fontWeight: 600, fontSize: "24px" }}>
            AMC Audiences
          </h1>
          <Tabs
            selectedTab={tab}
            tabs={[
              { label: "Templates", key: "create" },
              { label: "Audiences", key: "audiences" },
            ]}
            onTabChange={setTab}
          />
          {tab === "audiences" && <AMCAudienceDetails />}
          {tab === "create" && <AudiencesSection />}
        </Container>
      </PageContainer>
    </>
  );
};

export default AudienceDashboard;
